import React from "react";
import { FixedLengthContainer } from "../../../containers";

const FixedLength = (props) => {
  return <FixedLengthContainer {...props} />;
};

export default FixedLength;
